import React, { useState } from "react";
import styles from "./ActiveAmoContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AllInfoContainer } from "./components/AllInfoContainer/AllInfoContainer";
import { TrashIcon } from "../../assets/icons/TrashIcon";
import { useNavigate } from "react-router-dom";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import { setUpdateDataAmo } from "../../store/slices/amoSlice";
import {
  deleteIntegrationAmo,
  getIntegrationAmo,
} from "../../utils/api/actions/integrations/amo";
import { CategoryContainer } from "./components/CategoryContainer/CategoryContainer";
import { getTelegramIntegrations } from "../../utils/api/actions/integrations/telegram";
import { getWhatsappIntegrations } from "../../utils/api/actions/integrations/whatsapp";

export const ActiveAmoContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeDataAmo, isUpdateAmo, updateDataAmo, isErrorAmo } = useSelector(
    (state) => state?.amo
  );
  const { dataTg, dataWa } = useSelector((state) => state.integration);

  const [activeNav, setActiveNav] = useState("all info");
  const [isLoading, setIsLoading] = useState(false);

    // интеграции тг ва
    const combinedDataMessengers = React.useMemo(() => {
      return [
        ...(dataTg || []).map((tg) => ({ ...tg })),
        ...(dataWa || []).map((wa) => ({ ...wa })),
      ];
    }, [dataTg, dataWa]);

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: (
        <AllInfoContainer activeAmo={activeDataAmo} errorAmo={isErrorAmo} />
      ),
    },
    {
      name: "Воронки",
      value: "categories",
      component: <CategoryContainer combinedDataMessengers={combinedDataMessengers} categories={activeDataAmo?.dataCategories} />,
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);

    dispatch(
      getIntegrationAmo(
        activeDataAmo?.dataUser.userId,
        activeDataAmo?.dataUser.integrationId,
        setIsLoading
      )
    );
    dispatch(getTelegramIntegrations(activeDataAmo?.dataUser.userId));
    dispatch(getWhatsappIntegrations(activeDataAmo?.dataUser.userId));
  };

  const handleDelete = () => {
    dispatch(
      deleteIntegrationAmo(activeDataAmo?.dataUser?.integrationId, setIsLoading, navigate)
    );
  };



  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={`vk-${index}`}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null;
      })
      .filter(Boolean);
  };

  const errorEmptyAssistantId = () =>
    toast.error("Выберите ассистента!", {
      toastId: "customId",
    });

  const onCancelEdit = () => {
    dispatch(setUpdateDataAmo(false));
  };

  const onSaveUpdatedData = () => {
    if (
      updateDataAmo.assistantId &&
      updateDataAmo.assistantId !== "00000000-0000-0000-0000-000000000000"
    ) {
      console.log("onSaveUpdatedData");
    } else {
      errorEmptyAssistantId();
    }
  };

  const actions = [
    {
      className: styles.deleteButton,
      titleClassName: styles.titleDeleteButton,
      title: "Удалить",
      icon: <TrashIcon width={16} height={18} fill={"#cb3e3e"} />,
      onClick: handleDelete,
    },
  ];

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={onCancelEdit}
        onSaveUpdatedData={onSaveUpdatedData}
        isEditing={isUpdateAmo}
        title={"Интеграции"}
        path={"/integration"}
        actions={actions}
      />
      <div className={styles.navContainer}>{renderNavItems(navItems)}</div>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <div
            className={styles.body}
            style={{
              height: isErrorAmo && "calc(80% - 40px)",
              justifyContent: isErrorAmo && "center",
            }}
          >
            {renderBodyItems(navItems)}
          </div>
        </>
      )}
    </div>
  );
};
